<template>
    <v-layout class="mt-3" v-if="visa.extra.application_data.places_to_visit">
        <v-flex xs12 >
            <v-card class="mx-auto pa-2 elevation-0">
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <list-item-detail
                                :sub_title="visa.extra.application_data.places_to_visit"
                                :title="$vuetify.lang.t('$vuetify.places_to_visit_in_nepal')"/>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import ListItemDetail from "../../../components/ListItemDetail"

    export default {
        data: () => ({
            options: [
                {
                    text: "Nepal",
                    value: "Nepal"
                },
                {
                    text: "Abroad",
                    value: "Abroad"
                }
            ]
        }),

        components: {ListItemDetail},

        computed: {
            visa() {
                return this.$store.state.VisaSingle.visa;
            },
            dynamicName() {

                const n = this.visa.extra.application_data.place_staying === "Hotel"
                    ? this.$vuetify.lang.t("$vuetify.hotel")
                    : this.$vuetify.lang.t("$vuetify.place");
                return "Name of the " + n;
            }
        },
    };
</script>
